import {Component} from '@angular/core';
import {
    InspectorImplementation,
    OpenDeviceDetailsEvent
} from '../../../types';
import {
    DeviceId
} from '@webmate-web-core/shared/types/ids';
import {Device} from '@webmate-web-core/shared/types/devices/device';
import {DeviceService} from '@webmate-web-core/shared/services/device/device.service';
import {Subscription} from 'rxjs';
interface PropertiesJson {
    [key: string]: PropertiesJson | string;
}

@Component({
    selector: 'wm-devicedetails-inspector',
    templateUrl: './devicedetails-inspector.component.html',
    styleUrls: ['./devicedetails-inspector.component.less']
})

export class DeviceDetailsInspectorComponent implements InspectorImplementation {

    deviceId: DeviceId;
    device: Device;
    properties: any = {};
    groupedProperties: PropertiesJson;
    groupedData: { [key: string]: any } = {};
    expandedState: { [key: string]: boolean } = {};
    private deviceSubscription?: Subscription;

    constructor(private deviceService: DeviceService) {}

    handleInspectorEvent(event: OpenDeviceDetailsEvent): void {
        this.deviceId = event.targetDevice;
        this.deviceSubscription?.unsubscribe();
        this.deviceSubscription = this.deviceService.getDevice$(this.deviceId).subscribe(device => {
            delete device.properties["clipboard.lastKnownContent"];
            this.device = device;
            this.properties = device.properties;
            this.groupedProperties = this.groupJsonByPrefix(this.properties);
            this.groupedData = {};

            for (const key in this.groupedProperties) {
                this.groupedData[key] = Object.keys(this.groupedProperties[key]);
            }
        });
    }

    groupJsonByPrefix(json: PropertiesJson): PropertiesJson {
        const groupedJson: PropertiesJson = {};
        Object.entries(json).forEach(([key, value]) => {
            const prefix = key.split('.')[0];
            if (groupedJson[prefix]) {
                groupedJson[prefix][key] = value;
            } else {
                groupedJson[prefix] = { [key]: value };
            }
        });
        return groupedJson;
    }

    getGroupedDataKeys(): string[] {
        return Object.keys(this.groupedData);
    }

    toggleExpandedState(parentKey: string): void {
        this.expandedState[parentKey] = !this.expandedState[parentKey];
    }

    getBrowserKey(browser: any): string {
        return browser.browserType + ': ' + browser.version;
    }

    getNonNestedKeys(keyinput: any): string[] {
        return Object.keys(keyinput)
            .filter((key) => typeof keyinput[key] !== 'object' && key !== 'version' && key !== 'browserType');
    }

}
